import React from 'react';

import Icon from '@do/walrus/Icon';
import Text from '@do/walrus/Text';
import styled from 'styled-components';

import classNames from 'classnames';

import colors from '@do/walrus/scss/core/_colors.scss';
import vars from '@do/walrus/scss/core/_variables.scss';

const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  border-radius: ${vars.border_radius};
  padding: ${vars.whitespace_regular} ${vars.whitespace_medium};
  margin: ${vars.whitespace_small} 0;

  &.is-error {
    background-color: ${colors.red_lightest};
    border: ${vars.border_width_thin} solid ${colors.red};
  }
`;

interface BannerProps {
  type: 'error'; // We can add more types of banners in the future
  title: string;
  details?: string;
  className?: any;
  children?: React.ReactNode;
}

const Banner = (props: BannerProps) => {
  const { type, title, details, className, children } = props;

  const classes = classNames({
    [className]: className,
    'is-error': type === 'error'
  });

  const ICONS = {
    error: 'error'
  };

  return (
    <Container className={classes}>
      <Icon
        icon={ICONS[type]}
        large={true}
        className="do-u-mt--xsmall do-u-mr--regular"
      />
      <div>
        <Text type="small">{title}</Text>
        <Text type="p" className="do-u-textSmall do-u-ma--remove">
          {!!children ? children : details}
        </Text>
      </div>
    </Container>
  );
};

export default Banner;
